import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { selectUserRoles } from '../../../features/auth/authSlice';
import ClaimSubmitterActions from './ClaimSubmitterActions';
import ClaimsOfficerActions from './ClaimsOfficerActions';
import AdminActions from './AdminActions';
import ApproverActions from './ApproverActions';
import FinanceActions from './FinanceActions';

const QuickActionsGrid = () => {
  // Consolidate role selection at common ancestor to eliminate 5 duplicate store subscriptions
  const userRoles = useSelector(selectUserRoles, shallowEqual);

  return (
    <section className="mb-12">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8">
        {/* Claim Submission Actions - HR, Broker, CRM */}
        <ClaimSubmitterActions userRoles={userRoles} />
        
        {/* Claims Officer Actions */}
        <ClaimsOfficerActions userRoles={userRoles} />
        
        {/* Approver Actions */}
        <ApproverActions userRoles={userRoles} />
        
        {/* Finance Actions */}
        <FinanceActions userRoles={userRoles} />
        
        {/* Admin Actions */}
        <AdminActions userRoles={userRoles} />
      </div>
    </section>
  );
};

export default React.memo(QuickActionsGrid);
